import Utils from "../Common/Utils.js";


//Function to format temperature data
const formatTemperature = (temperature) => {
  if(temperature > 42){
    return (">42°C");
  }
  else if(temperature < 24){
    return ("<24°C");
  }
  else{
    return (temperature.toFixed(1));
  }
}

//Function to get difference in minutes between 2 dates 
const getDiffInMinutes = (comparedDate, refDate) => {
    return ((comparedDate - refDate) / (1000 * 60));
}

//Function to get index of max temperature in the last 3h
const getIndexForMax3hComputation = (TemperatureDataset) => {
        
    //Set current date
    let date = new Date();
    let current_Date = new Date(
        date.getFullYear(), 
        date.getMonth(), 
        date.getDate(), 
        date.getHours(), 
        date.getMinutes(), 
        date.getSeconds(), 
        date.getMilliseconds()
    )

    let diffInMinutes = -1000;
    let index = -1;

    //Start checking the tab with the result of last 3h temperature request from the bottom to determine the index of the oldest data aged of less than 3h before current time
    if (TemperatureDataset.length >1){
      for(let i = TemperatureDataset.length-2; i > 0 ; i--){
        //Check is the data if more recent than 3h ago or not
        diffInMinutes = getDiffInMinutes(current_Date, new Date(TemperatureDataset[i].x));

        //If data is more recent than 3h ago, we can save its index in the tab and then end the for loop to start determinate max temperature
        if(diffInMinutes < 180){
            index = i;
        }
      }
    }

    return index;

}

//Function to retrieve last 3h max temperature and its color
const getMaxTemperatureLast3h = (TemperatureDataset, threshold, threshold2) => {

    let max_3h = {
        temperature : -1,
        color: "#767676"
    };

    let indexForMax3hComputation = getIndexForMax3hComputation(TemperatureDataset);
  	//If some data in TemperatureDataset dates are more recent than 3h ago
    if(indexForMax3hComputation >= 0){
    	for(let i = indexForMax3hComputation; i < TemperatureDataset.length; i++){
       	    if(Number.parseFloat(TemperatureDataset[i].y) > max_3h.temperature){
       	        max_3h.temperature = TemperatureDataset[i].y;
       	    }
       	}
       	//To indicate only on decimal in max temperature
       	max_3h.temperature = formatTemperature(max_3h.temperature);
        if ((max_3h.temperature >34.7)&&(max_3h.temperature <42.00)){
            if (threshold2 === null || threshold2 === undefined) {
                threshold2 = Utils.setDefaultThreshold2("temperature")
            }
          max_3h.color = Utils.setMeasureColor(max_3h.temperature, threshold, 1.00, 'sup', threshold2);
        }
    }

    //if no data during the last 3h, then display "NC"
    else{
        max_3h = {
        	temperature : "-",
          color: "#767676"
        };  
    }
    return max_3h;

}

//Const to import functions in other files
const MaxTemperatureLast3h = {
  getMaxTemperatureLast3h
};

export default MaxTemperatureLast3h;